/**
 * Portal Financeiro Page (Placeholder)
 *
 * Story: 11-1-portal-de-acesso-externo
 * Task: Frontend - Portal Routes Configuration
 *
 * Placeholder for future Story 11.3 or 11.4
 */
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, AlertCircle } from "lucide-react";

const PortalFinanceiro: React.FC = () => {
  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8 space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-emerald-900">Financeiro</h1>
        <p className="text-sm text-slate-600 mt-1">Gestão financeira do parceiro</p>
      </div>

      <Card className="border-emerald-100/80 bg-white/80 backdrop-blur-sm">
        <CardHeader className="border-b border-emerald-50 pb-4">
          <div className="flex items-center space-x-2">
            <div className="h-9 w-9 rounded-lg bg-emerald-100 text-emerald-700 flex items-center justify-center">
              <DollarSign className="h-5 w-5" />
            </div>
            <CardTitle className="text-emerald-900">Pagamentos e Cobranças</CardTitle>
          </div>
          <CardDescription>Visualize e gerencie seus pagamentos, cobranças e saldo</CardDescription>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center justify-center py-12 space-y-4">
            <div className="h-20 w-20 rounded-full bg-emerald-50 flex items-center justify-center">
              <AlertCircle className="h-10 w-10 text-emerald-300" />
            </div>
            <p className="text-lg font-medium text-slate-900">Em breve</p>
            <p className="text-sm text-slate-500 text-center max-w-md">
              A gestão financeira completa estará disponível em breve.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PortalFinanceiro;
